import { lazy, Suspense } from 'react';
import { Card } from '@bid/shared-ui';

const LocationGenerator = lazy(() => import('locationGenerator/LocationGenerator'));

export const LocationGeneratorPage = (): JSX.Element => {
  return (
    <div data-testid="location-generator-page">
      <Suspense
        fallback={
          <Card title="Loading Location Generator...">
            <div className="flex items-center justify-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bitd-gold"></div>
            </div>
          </Card>
        }
      >
        <LocationGenerator />
      </Suspense>
    </div>
  );
};
